// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"c8bc0447","598":"3a9ee24e","703":"3e9cabf6"}[chunkId] + ".chunk.js";
};